import { useState } from 'react';
import { ChevronDown, ChevronUp, Layers } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import moduleRelationships from '@/help/moduleRelationships';
import marketingModuleRelationships from '@/help/marketingModuleRelationships';
import agendaModuleRelationships from '@/help/agendaModuleRelationships';

const HUB_CONFIG = {
  ai: { data: moduleRelationships, label: 'Las 6 capas del sistema IA', accent: '#0284C7', bg: 'bg-[#F0F9FF]', border: 'border-[#BAE6FD]', hoverBg: 'hover:bg-[#E0F2FE]', textPrimary: 'text-[#0C4A6E]' },
  marketing: { data: marketingModuleRelationships, label: 'Las 6 capas de Marketing', accent: '#D946EF', bg: 'bg-[#FDF4FF]', border: 'border-[#F0ABFC]', hoverBg: 'hover:bg-[#FAE8FF]', textPrimary: 'text-[#701A75]' },
  agenda: { data: agendaModuleRelationships, label: 'Agenda ↔ CRM', accent: '#0891B2', bg: 'bg-[#ECFEFF]', border: 'border-[#A5F3FC]', hoverBg: 'hover:bg-[#CFFAFE]', textPrimary: 'text-[#164E63]' },
};

export default function ModuleRelationshipHelp({ hub = 'ai' }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const cfg = HUB_CONFIG[hub] || HUB_CONFIG.ai;
  const rel = cfg.data;
  return (
    <div className={`${cfg.bg} ${cfg.border} border rounded-lg`} data-testid={`help-module-relationships-${hub}`}>
      <button type="button" onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-2 px-3 py-2 text-left">
        <Layers className="w-3.5 h-3.5 flex-shrink-0" style={{ color: cfg.accent }} />
        <span className={`text-xs font-medium ${cfg.textPrimary} flex-1`}>{cfg.label}</span>
        {open ? <ChevronUp className="w-3.5 h-3.5" style={{ color: cfg.accent }} /> : <ChevronDown className="w-3.5 h-3.5" style={{ color: cfg.accent }} />}
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-1.5">
          {rel.layers.map(l => (
            <button key={l.key} type="button" onClick={() => l.path && navigate(l.path)} disabled={!l.path}
              className={`w-full flex items-center gap-2 px-2 py-1.5 rounded ${cfg.hoverBg} transition-colors text-left ${!l.path ? 'opacity-50 cursor-not-allowed' : ''}`}>
              <span className="w-5 h-5 rounded text-white text-[10px] flex items-center justify-center font-bold flex-shrink-0" style={{ backgroundColor: cfg.accent }}>{l.order}</span>
              <span className={`text-xs font-medium ${cfg.textPrimary} flex-1`}>{l.name}</span>
              <span className="text-[10px] text-[#64748B]">{l.description}</span>
            </button>
          ))}
          <p className="text-[10px] text-[#64748B] mt-1 italic">{rel.futureLayer}</p>
        </div>
      )}
    </div>
  );
}
